import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { ActionIcon } from "PFComponents/action_icon";
import { Avatar } from "PFComponents/avatar";
import { profileHash } from "PFCore/helpers/profile_hash";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Shortlist } from "PFTypes";

import css from "./profile_label.module.scss";

type ProfileLabelProps = {
  shortlist: Shortlist;
  removeProfileId: (id: number) => void;
  isUnbiasedMode?: boolean;
};

export const ProfileLabel = ({
  shortlist: { profile },
  removeProfileId,
  isUnbiasedMode
}: ProfileLabelProps) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  return (
    <div className={css.root}>
      <div>
        {isUnbiasedMode ? (
          <Avatar size={30} backgroundColor="#ffc0cb" text={profileHash(profile.id)} />
        ) : (
          <ProfileAvatarConnected profile={profile} size={30} />
        )}
      </div>
      <div className={css.name}>{getUnbiasedProfileName(profile, !!isUnbiasedMode)}</div>
      <ActionIcon name="cross" size="xxs" onClick={() => removeProfileId(profile.id)} />
    </div>
  );
};
